export default __webpack_public_path__ + "static/media/05_AeroWin.85021999.png";